<template>
    <div class="document-list document-list--collapsed">
      <VGrid>
        <div slot="gridItem" type="3" v-for="(item, index) in selected" :key="index">
          <VLoadingSpinner size="medium" v-if="!documentProcessed" />
            <div class="document-list__item">
                <div class="document-list__item__pages">
                    {{ item.total_pages == 1 ? $t('createEnvelope.documentList.onePage') : $t('createEnvelope.documentList.pageCount', { total: item.total_pages }) }}
                </div>
                <VLoadingSpinner size="medium" v-if="!processedDocuments.includes(item.id)" />
                <VImage
                  @loaded="documentProcessed(item.id)"
                  class="document-list__item__image"
                  :src="item.images[0]"
                  data-hj-suppress
                />
                <div class="document-list__item__details">
                    <div class="document-list__item__details__title" data-hj-suppress>
                    {{ item.title }}
                    </div>
                </div>
            </div>
        </div>
      </VGrid>
    </div>
</template>

<script>
import VGrid from '@/components/deprecated/organisms/Grid.vue';
import VLoadingSpinner from '@/components/deprecated/atoms/LoadingSpinner.vue';
import VImage from '@/components/atoms/Image.vue';

export default {
  name: 'VDocumentList',
  props: {
    selected: {
      type: Array,
    },
  },
  components: {
    VGrid,
    VImage,
    VLoadingSpinner,
  },
  data() {
    return {
      processedDocuments: [],
    };
  },
  methods: {
    documentProcessed(itemId) {
      this.$store.commit('envelopes/SET_DOCUMENT_PROCESSED', { processed: true });
      this.processedDocuments.push(itemId);
    },
  },
};
</script>

<style scoped>
.document-list {
  background: #fff;
  border: 1px solid var(--color-border);
  height: 350px;
  overflow: auto;
  padding: var(--spacing-base);
  position: relative;
}

.document-list:after {
  content: '';
  display: block;
  clear: both;
}

.document-list__item {
  position: relative;
  border-radius: 9px;
}

.document-list__item__pages {
  position: absolute;
  top: var(--spacing-xs);
  right: var(--spacing-xs);
  padding: var(--spacing-xs) var(--spacing-small);
  font-size: 11px;
  background: #222;
  color: #fff;
  font-weight: bold;
  border-radius: 30px;
}

.document-list__item__details {
  text-align: center;
  background: #222;
  padding: var(--spacing-xs);
  color: #fff;
  font-size: 14px;
  font-weight: bold;
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  pointer-events: none;
  color: #fff;
  border-bottom-left-radius: 2px;
  border-bottom-right-radius: 2px;
}

.document-list__item__details__title {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-bottom: var(--spacing-xs);
}

.document-list__item__details__created {
  font-size: 12px;
}

.document-list__item__details__created svg {
  margin-right: var(--spacing-xs);
}

.document-list--collapsed {
  height: auto;
  padding: 0;
  overflow: initial;
  background: transparent;
  border: 0;
}

.document-list--collapsed .o-grid {
  grid-template-columns: repeat(auto-fit, minmax(130px, 150px)) !important;
}

.document-list--collapsed .o-grid__item {
  grid-column: auto;
}

.document-list--collapsed .document-list__item {
  border: 1px solid var(--color-border);
  border-radius: 9px;
  box-shadow: 0px 0px 5px -2px var(--color-border);
  overflow: hidden;
}

.document-list--collapsed .document-list__item__details {
  border-bottom-left-radius: 9px;
  border-bottom-right-radius: 9px;
}
</style>
